module.exports = "/_next/static/images/OgJourneys-877025f99206c91ebf9dbbb09266c245.png";